import { render } from "./ParkingList.vue?vue&type=template&id=8a55c8ce"
import script from "./ParkingList.vue?vue&type=script&lang=js"
export * from "./ParkingList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__